import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=2c337427&scoped=true"
import script from "./ProjectManager.vue?vue&type=script&lang=js"
export * from "./ProjectManager.vue?vue&type=script&lang=js"
import style0 from "./ProjectManager.vue?vue&type=style&index=0&id=2c337427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c337427",
  null
  
)

export default component.exports